
<template>
  <div class="modal fade slide-right" id="paymentModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog modal-sm modal-payment" style="width: 35%;">
          <div class="modal-content-wrapper">
              <div class="modal-content">
                  <div class="modal-header clearfix text-left">
                      <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        <i class="pg-close fs-14"></i>
                      </button>
                      <div class="col-md-12 modal-left">
                          <h3 class="modal-title" >Paiement de commande</h3>
                      </div>
                  </div>
                  <div class="modal-body"  >
                    <div class="col-md-12 modal-right">
                        <h4>Montant : {{(total / 100).toFixed(2)}} €</h4>
                        <h4 v-text="modal.form.title"></h4>
                        <div v-if="errors.length" class="alert alert-danger" role="alert">
                          <ul>
                            <li v-for="(message, idx) in errors" :key="'payment-error-' + idx">{{message}}</li>
                          </ul>
                        </div>
                        <div v-if="cb_online" class="text-center row agency-payment-zone">
                          <p>Cette fenêtre se fermera automatiquement en cas de succès.</p>
                        </div>
                        <div v-else class="text-center row agency-payment-zone">
                            <section class="m-10" v-html="modal.form.content"></section>
                            <resource-form v-if="renderForm"
                                            ref="paymentForm"
                                           :schema="modal.form.schema"
                                           :model="modal.form.model"
                                           :show-notifications="false"
                                           :submit-button="false">
                            </resource-form>
                            <div class="text-center agency-payment-zone">
                                <span v-text="modal.after_form_text"></span>
                                <template v-if="paymentStatus.sended">
                                    <p v-if="paymentStatus.succeeded">La demande à été effectuée avec succès.</p>
                                    <p v-else>Envoie de la demande échoué.</p>
                                </template>

                            </div>
                        </div>
                        <div>
                          <button class="btn btn-complete btn-cons no-margin inline" @click.prevent="onClick" v-if="!cb_online">Confirmer</button>
                          <button type="button" class="btn btn-default btn-cons no-margin inline pull-right"
                                  data-dismiss="modal" @click="$emit('cancel')">Annuler
                          </button>
                        </div>
                      </div>
                  </div>
                  <div class="modal-footer">

                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
  import ResourceForm from "components/Forms/ResourceForm"

  import Vue from 'vue'
  import {mapActions} from 'vuex'
  import cookies from 'cookiesjs'

    export default {

      name: 'Step4Modal',

      props: ["block", "modal", "total", "paymentStatus", "cb_online","order", "errors"],

      components: {
        ResourceForm,
      },

      data () {
        return {}
      },

      mounted () {
        $(this.$el).modal()
      },

      beforeDestroy () {
          $(this.$el).modal('hide')
          $('body').removeClass('modal-open')
          $('.modal-backdrop').remove()
      },

      computed : {
        renderForm () {
          return !_.isEmpty(this.modal.form.schema) || this.cb_online
        }
      },

      methods:{
        showError(msg) {
          console.error(msg)
        },

        onClick () {
          let data = this.renderForm ? this.$refs.paymentForm.dataToSend() : null

          this.renderForm && this.$refs.paymentForm.handleSubmit({})

          if (data == null) {
            data = {validation_method:"unit-cash"}
          }

          this.$emit('send', data)
        }
      },

    }
</script>



// WEBPACK FOOTER //
// client/components/Demands/Step4Modal.vue